(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  const selectors = form.querySelectorAll('.product-option-select');
  const productDataEl = document.querySelector('[data-product-json]');
  if (!productDataEl) return;

  const productData = JSON.parse(productDataEl.textContent);
  const variants = productData.variants;
  const variantInput = form.querySelector('input[name="id"]');

  function updateVariantId() {
    const selectedOptions = Array.from(selectors).map(select => select.value);
    const matchedVariant = variants.find(v =>
      v.options.every((opt, idx) => opt === selectedOptions[idx])
    );

    if (matchedVariant) {
      variantInput.value = matchedVariant.id;
      const button = form.querySelector('[data-add-to-cart]');
      if (button) {
        button.disabled = !matchedVariant.available;
      }
    }
  }

  selectors.forEach(select => {
    select.addEventListener('change', updateVariantId);
  });

  updateVariantId(); // inicial
});

  } catch(e) { console.error(e); }
})();
})();
